import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Checkbox } from '../../../../../CommonComponents/OPL/Checkbox/Checkbox';

interface Props {
  isDefaultExcluded?: boolean;
  control: Control<any>;
}

export const GrossEstateCheckbox = ({ isDefaultExcluded, control }: Props) => {
  return (
    <Controller
      control={control}
      name="includeInGrossEstate"
      render={({ field }) => {
        return (
          <Checkbox
            checked={
              isDefaultExcluded ? !!field.value : field.value === null ? false : !field.value
            }
            onChange={evt =>
              field.onChange(isDefaultExcluded ? evt.target.checked : !evt.target.checked)
            }
          >
            {isDefaultExcluded ? 'Include in Gross Estate' : 'Exclude from Gross Estate'}
          </Checkbox>
        );
      }}
    />
  );
};
